if (!bp) {
	let bp = window.matchMedia("(max-width: 47.5rem)");
}

/*
	Form Formats
*/
const digitsOnly = value => value.replace(/[^\d]/g, "");
let telInputs = document.querySelectorAll("input[type='tel'][id*='product_id_']");
const removeNonDigits = e => {
	const key = e.key;
	const target = e.target;
	let value = target.value || '';
	let temp = (value && value != '') ? Number(digitsOnly(value)) : '';

	if (key === "Backspace" || key === "Delete") {
		target.value = value;
		return value;
	} else {
		target.value = temp;
		return temp;
	}
}
const telInputFnc = e => {
	const key = e.key;
	const target = e.target;
	let value = target.value;
	let temp = value ? Number(digitsOnly(value)) : null;
	const min = target.getAttribute('min') ? Number(target.getAttribute('min')) : null;
	const max = target.getAttribute('max') ? Number(target.getAttribute('max')) : null;

	if (key === "Backspace" || key === "Delete") {
		target.value = min ? min : '';
	}

	if (!value || value === '') {
		target.value = min ? min : '';
	}

	if ( value && (min && (temp < min)) ) {
		// console.log("should be min")
		target.value = min;
	} else if ( value && (max && (temp > max)) ) {
		// console.log("should be max")
		target.value = max;
	} else {
		// console.log("should be default")
		target.value = temp;
	}

}

const quantityForm = () => {
	let quantityFormItems = document.querySelectorAll("input[type='tel'][id*='product_id_']");
	if (quantityFormItems) {
		quantityFormItems.forEach(quantityFormItem => {
			quantityFormItem.addEventListener("keydown", e => removeNonDigits(e));
			quantityFormItem.addEventListener("keyup", e => removeNonDigits(e));
			quantityFormItem.addEventListener("change", e => telInputFnc(e));
			quantityFormItem.addEventListener("blur", e => telInputFnc(e));
		})
	}
}

/* Menu BG change */
// const mobileNavHeader = document.querySelector("#mobileNavHeader");
// const pageSections = document.querySelectorAll(".c-page__main > section, .c-page__main > section > section, .c-page__main .section");
// if (pageSections) {
// 	const setHeaderClassesForMobileScrool = entries => {
// 		entries.forEach(entry => {
// 			let target =  entry.target;
// 			// console.log(entry)
// 			if(entry.isIntersecting)  {
// 				if (!target.querySelector('.tw-bg-light, .tw-bg-light-light')) {
// 					mobileNavHeader.classList.remove('!tw-bg-black/50');
// 					console.log('not light bg!');
// 				} else {
// 					console.log('light bg!');
// 					mobileNavHeader.classList.add('!tw-bg-black/50');
// 				}
// 				  // observer.unobserve(entry.target)
// 			}
// 		});
// 	}
// 	const sectionObserver = new IntersectionObserver(setHeaderClassesForMobileScrool);
// 	pageSections.forEach(section => {
// 		sectionObserver.observe(section);
// 	})
// }



// const handlesAddToCart = document.querySelectorAll("._addToCart");
// const productThumbnails = document.querySelectorAll('._product-thumbnail');

// const initProductThumbails = () => {
// 	productThumbnails.forEach( thumbnail => {
// 		thumbnail.addEventListener("click", async e => {
// 			e.preventDefault();

// 			productImageSwap(e);

// 		})
// 	})
// }

// Shopify.onCartUpdate =  (cart) => {
// 	alert('There are now ' + cart.item_count + ' items in the cart.');
// };


window.addEventListener('DOMContentLoaded', () => {
	setHeaderHeight();
	setTimeout(() => {

		if (telInputs) {
			quantityForm()
		}

		// if (handlesAddToCart) {
		// 	handleAddToCart()
		// }


		// if (productThumbnails) {
		// 	initProductThumbails();
		// }
		// document.querySelectorAll('.select-variant').forEach(checkbox => {
		// 	checkbox.addEventListener("change", (e) => {
		// 		if (e.target.classList.hasAtrribute('checked')) {
		// 			e.target.classList.removeAttribute('checked')
		// 		}
		// 	})
		// })

		// setTimeout(() => {
		// 	const checkedRadios = document.querySelectorAll("input[type='radio'][checked]");
		// 	console.log(checkedRadios);
		// 	checkedRadios.forEach(checked => checked.setAttribute('checked','checked'));
		// }, 10);

	}, 10);
});

